import { render } from "./CustomerFollowList.vue?vue&type=template&id=7b48b6e2&scoped=true"
import script from "./CustomerFollowList.vue?vue&type=script&lang=js"
export * from "./CustomerFollowList.vue?vue&type=script&lang=js"

import "./CustomerFollowList.vue?vue&type=style&index=0&id=7b48b6e2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b48b6e2"],['__file',"src/views/qywx/common/partner/customer/CustomerFollowList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b48b6e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b48b6e2', __exports__)) {
    api.reload('7b48b6e2', __exports__)
  }
  
  module.hot.accept("./CustomerFollowList.vue?vue&type=template&id=7b48b6e2&scoped=true", () => {
    api.rerender('7b48b6e2', render)
  })

}


export default __exports__